// SearchBar.js
import React, { useState } from 'react';
import './SearchBar.css';
import { FaMicrophone } from 'react-icons/fa';

function SearchBar({ query, setQuery, handleSearch, loading }) {
  const [suggestions, setSuggestions] = useState([]);
  const [listening, setListening] = useState(false);

  const handleInputChange = async (e) => {
    const value = e.target.value;
    setQuery(value);
  };

  const handleSuggestionClick = (suggestion) => {
    setQuery(suggestion);
    setSuggestions([]);
    handleSearch(suggestion);
  };

  const startListening = () => {
    if (!('webkitSpeechRecognition' in window)) {
      alert('Speech recognition not supported in this browser.');
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = 'en-US';
    recognition.start();

    recognition.onstart = () => {
      setListening(true);
    };

    recognition.onresult = (event) => {
      const speechResult = event.results[0][0].transcript;
      setQuery(speechResult);
      handleSearch(speechResult);
      setListening(false);
    };

    recognition.onerror = (event) => {
      console.error('Speech recognition error', event.error);
      setListening(false);
    };
  };

  return (
    <div className="search-bar">
      <input
        type="text"
        placeholder="What would you like to ask..."
        value={query}
        onChange={handleInputChange}
        onKeyDown={(e) => e.key === 'Enter' && handleSearch(query)}
        aria-label="Search"
      />
      <button onClick={() => handleSearch(query)} disabled={loading} aria-label="Search Button">
        {loading ? 'Searching...' : 'Search'}
      </button>
      {suggestions.length > 0 && (
        <ul className="autocomplete-suggestions">
          {suggestions.map((suggestion, index) => (
            <li key={index} onClick={() => handleSuggestionClick(suggestion)}>
              {suggestion}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default SearchBar;
